import { useAppSelector } from "../../hooks/StoreHooks";

export const useProfileData = () =>
  useAppSelector((state) => state.profile.data);